<div class="select-box">
  <label>
    <span>{{label}}</span>
    <select (change)="onOptionChangeHandle(selectedOption)" [(ngModel)]="selectedOption">
      <option *ngIf="defaultOption" [ngValue]="defaultOption" selected>{{defaultOption[valueProp]}} (me)</option>
      <option *ngFor="let option of options" [ngValue]="option">{{option[valueProp]}}</option>
    </select>
  </label>
</div>
